import React, { ComponentProps, forwardRef } from 'react';

import { Animated, View } from 'react-native';

import useRotateAnimation from './use-rotate-animation';

export interface IRotateAnimatedViewProps extends ComponentProps<typeof Animated.View> {
  isRotated?: boolean;
  fromDeg?: number;
  toDeg?: number;
}

export const RotateAnimatedView = forwardRef<View, IRotateAnimatedViewProps>(
  ({ isRotated = false, children, fromDeg = 0, toDeg = 180, style, ...props }, ref) => {
    const { rotateData } = useRotateAnimation({ isRotated, fromDeg, toDeg });

    return (
      <Animated.View {...props} ref={ref} style={[style, { transform: [{ rotate: rotateData }] }]}>
        {children}
      </Animated.View>
    );
  }
);

RotateAnimatedView.displayName = 'RotateAnimatedView';
export default RotateAnimatedView;
